// Public entry point of the Unfathomable engine (shared by server and client).

export * from "./types";
export * from "./board";
export * from "./state";
export { validateAnswer, type Decision, type DecisionKind, type DieInfo, type Option, type AnswerMap } from "./engine";
export { Game, type AnswerRecord, type DecisionRecord, type GameBackup, type TimelineEntry } from "./game";
export { botChoice, botRandom, randomChoice, type BotStyle } from "./bots";
export { renderTranscript } from "./transcript";
export { buildView, type GameView, type PlayerView, type SpaceView, type DecisionView } from "./view";
export { kCharacters, kCaptainSuccession, kKeeperSuccession, type CharacterDef } from "./data/characters";
export { kSkillDefs, skillDef, type SkillDef } from "./data/skills";
export {
  kMythos, kMythosById, kWaypoints, kWaypointById, kSpells, kSpellById, kItems, kItemById, kDamageCards, kDamageById,
  type MythosDef, type WaypointDef, type SpellDef, type ItemDef, type DamageDef,
} from "./data/cards";

export const kRoomName = "unfathomable";

/** Colyseus message names (client <-> server). */
export namespace Api {
  /** client -> server: { decisionId, choice } */
  export const kAnswer = "answer";
  /** client -> server: lobby configuration (host only) */
  export const kConfigure = "configure";
  /** client -> server: claim a seat { seat } */
  export const kTakeSeat = "takeSeat";
  /** client -> server: start the game (host only) */
  export const kStart = "start";
  /** client -> server: propose an undo { decisionId, reshuffle } */
  export const kProposeUndo = "proposeUndo";
  /** client -> server: vote on the pending undo { approve } */
  export const kVoteUndo = "voteUndo";
  /** client -> server: request a backup download */
  export const kRequestBackup = "requestBackup";
  /** client -> server: restore from an uploaded backup (host only) { backup } */
  export const kRestore = "restore";
  /** server -> client: personal game view */
  export const kView = "view";
  /** server -> client: lobby state */
  export const kLobby = "lobby";
  /** server -> client: backup JSON */
  export const kBackup = "backup";
  /** server -> client: error message */
  export const kError = "error";

  export interface AnswerRequest { decisionId: number; choice: string[] }
  export interface ProposeUndoRequest { decisionId: number; reshuffle: boolean }
  export interface VoteUndoRequest { approve: boolean }
}

export * from "./lobby";
